module.exports = __webpack_public_path__ + "assets/img/4.bf472773.png";